const getters = {
    getMailingListOfType: (state) => (type) => {
        return _.filter(state.mailinglist, { 'type': type });
    }
}

export default getters